export default {
  data() {
    return {
      showContent: false,
      tableSearch: '',
      headers: [
        { text: 'Город', value: 'city_name', sortable: false, align: 'start' },
        { text: 'Название магазина', value: 'point_name', sortable: false },
        { text: 'Адрес', value: 'address', sortable: false },
      ],
    };
  },
  computed: {
    items() {
      return this.$store.getters['partners/getItems'];
    },
    pdfFileUrl() {
      return this.$store.getters['partners/getPdfFileUrl'];
    },
  },
  created() {
    this.$store.dispatch('partners/GetList');
  },
};
